import React, { useEffect, useState } from 'react'
import { logo, placeholderImg } from '../constants/files'
import { NavLink } from 'react-router-dom'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import MobileHeader from './MobileHeader';
import { actualitiesLink, directLink, homeLink } from '../constants/endspoints';
import { useQuery } from '@tanstack/react-query';
import { fetchArticles } from '../api/article';
import Modal from 'react-responsive-modal';
import IsEmpty from './IsEmpty';
import { getFirstImageSrc, getTextFromHTML } from '../constants/functions';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

const Header = () => {  

    const navLinks =  [
        {nav: 'Grille TV', link: directLink},
        {nav: 'Actualités', link: actualitiesLink},
        {nav: 'Direct', link: homeLink, icon:'fa-light fa-signal-stream color-red fs-8s'},
    ]  


    const[title, setTitle] = useState('')
    const[openS, setOpenS] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [researchData, setResearchData] = useState([]);

    const { data, status } = useQuery({
        queryKey: ["actualitySearch", title, currentPage],
        queryFn: () => fetchArticles({ title, page: currentPage, 'order[id]': "desc" }),
        enabled: !!title,
        retry: false,
        keepPreviousData: true, // important si tu veux garder les données entre les pages
    });

    useEffect(() => {
        if (data?.data?.member?.length > 0) {
            setResearchData(prev => [...prev, ...data.data.member]);
        }
    }, [data]);

    useEffect(() => {
        if (
            data?.data?.totalItems &&
            researchData.length < data.data.totalItems &&
            !data.isFetching
        ) {
            setCurrentPage(prev => prev + 1);
            
        }
    }, [researchData, data]);
    


    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    return (
        <header className=' position-sticky top-0 bg-black'>
            <div className='container-xxl py-2'>
                <nav className=' row justify-content-md-around justify-content-lg-between justify-content-between align-items-center'>
                    {/* Logo */}
                    <div className=' col-auto'>
                        <NavLink reloadDocument to={'/'}>
                            <LazyLoadImage 
                            src={logo} 
                            alt='ubiznewtv' 
                            style={{height:'3rem'}} 
                            placeholder={<div className=' w-100 h-100'><img src={placeholderImg} className=' h-100 object-fit-contain' alt='' /></div>}
                            effect="black-and-white"
                            height={'3rem'} />
                        </NavLink>
                    </div>
                    {/* searchbar and links */}
                    <div className='col-lg-8 col-md-10 col'>
                        <div id='language-switcher' className='d-md-flex d-none row justify-content-evenly align-items-center text-white'>
                            {/* Searchbar */}
                            <div className=' col'>
                                <div className=' w-100 px-2 border border-1 d-flex align-items-center'>
                                    <i className=' fa fa-search'></i>
                                    <input 
                                        type='search'
                                        onClick={() => setOpenS(true)}
                                        placeholder='Rechercher une actualité' 
                                        className='form-control shadow-none bg-black border-0 fs-9s text-white py-1'
                                    />
                                </div>
                            </div>
                            {/* NavLinks */}
                            <div className=' col-auto'>
                                <div className=' row justify-content-around align-items-center'>
                                    {
                                        navLinks.map((link, index) => (
                                            <NavLink to={link.link} key={index} reloadDocument className=' col-auto text-white fs-9s main-nav-link d-flex align-items-center'>
                                                {link.icon && <i className={`${link.icon} me-1`}></i>}
                                                {link.nav}
                                            </NavLink>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>

                        {/* Mobile */}
                        <div className=' d-md-none d-flex row justify-content-end align-items-center gx-3'>
                            <MobileHeader/>
                        </div>
                    </div>
                </nav>
            </div>


            <Modal 
                open={openS} 
                onClose={() => { setOpenS(false); setTitle('') }} 
                center={false}
                classNames={{modal:"bg-black text-white border rounde-0"}} 
                styles={{ root: {zIndex: 1101}, modal: {maxHeight: '95vh'}, closeButton: {marginRight:"-8px", marginTop:"-12px"} }}
                closeIcon={<i className='fa-regular fa-xmark text-white fs-6'></i>}
                focusTrapped={true}
            >
                <div className=' w-100 px-2 mb-2 border border-1 d-flex align-items-center'>
                    <i className=' fa fa-search'></i>
                    <input 
                        type='search'
                        onChange={(e) => {setTitle(e.target.value); setResearchData([]); setCurrentPage(1)}}
                        placeholder='Rechercher' 
                        style={{minWidth: windowWidth > 450 ? '400px' : ''}}
                        className='form-control shadow-none bg-black border-0 fs-9s text-white py-1'
                    />
                </div>
                <div className='w-100'>
                    {title ?
                        status === "pending" ?
                        [1,2,3,4,5].map((i) => (
                            <div key={i} className='row justify-content-between align-items-start placeholder-wave mb-2 pb-2 pt-1 border-bottom border-1'>
                                <div className='placeholder bgcolor-primary col-auto d-md-block d-none' style={{height:"3.7rem",width:"4.5rem"}}></div>
                                <div className='col'>
                                    <div className='placeholder-sm fw-bold bg-white col-12'></div>
                                    <div className='placeholder mb-0 fs-8s fw-bold bg-white col-10'></div>
                                    <div className='placeholder fs-8s fw-bold bg-white col-11'></div>
                                </div>
                            </div>
                        ))
                        :status === "error" ?
                            <IsEmpty icon={"fa-light fa-exclamation-circle mb-2"} message={"Une erreur c'est produite"} />
                        :researchData?.length <= 0 ?
                            <IsEmpty icon={"fa-light fa-newspaper"} message={" Aucune correspondance trouvée "} />
                        :researchData?.map((actuality, index) => 
                            <NavLink to={`${actualitiesLink}/${actuality.id}`} key={index} className='row justify-content-between align-items-start gx-1 mb-2 pb-2 pt-1 border-bottom border-1'>
                                <div className='col-auto'>
                                    <img 
                                        src={getFirstImageSrc(actuality?.content)? getFirstImageSrc(actuality?.content) : placeholderImg } 
                                        alt={actuality?.title} 
                                        className='object-fit-cover' 
                                        style={{height:"3.7rem",width:"4.5rem"}} />
                                </div>
                                <div className='col text-white'>
                                    <h3 className='fw-bold mb-0 text-truncate-1'>{actuality?.title}</h3>
                                    <p className='mb-0 fs-7s text-truncate-2'>{getTextFromHTML(actuality?.content)}</p>
                                    <p className='mb-0 fs-6s text-end'>{ format(actuality?.createdAt, "dd MMM yyyy", {locale:fr})}</p>
                                </div>
                            </NavLink>
                        )
                    :null}
                </div>
            </Modal>


        </header>
    )
}

export default Header